export const CONSTANT_JIT_OPERATION = {
    REASON_DELETION_REQ_SUBMIT: 'Reason delete request submitted successfully. Please get in touch with the approvers for review',
    REASON_CREATION_REQ_SUBMIT: 'Reason create request submitted successfully. Please get in touch with the approvers for review',
    REASON_UPDATE_REQ_SUBMIT: 'Reason update request submitted successfully. Please get in touch with the approvers for review',
    REASON_SUBMIT_ERROR: 'Failed to submit the operation request. Please try again',
    NEW_MAJOR_REASON: 'New Major Reason',
    DISPLAY_HEADER_MSG: 'Displaying list of Major Reasons',
    OPERATION: 'Operation',
    REASON_CONFIGURATION_HEADER: 'PCSK Access Reasons Configuration',
    MINOR_REASONS: 'Minor Reasons',
    CREATE_MINOR_REASON: 'Create Minor Reason',
    LABEL: 'Label',
    DESCRIPTION: 'Description',
    URL: 'URL',
    NOTE: 'Note',
    SORT_ORDER: 'Sort Order',
    SHOW_RECOMMENDED_ACTIONS: 'Show Recommended Actions',
    EDIT: 'Edit',
    DELETE: 'Delete',
}